<span class="labeled-field__label" [id]="labelId">
  {{ label }}
  @if (required) {
    <span class="labeled-field__required" aria-hidden="true">*</span>
  }
</span>
<ng-content></ng-content>
@if (hint) {
  <span class="labeled-field__hint">{{ hint }}</span>
}
